import styled from 'styled-components';
import { styled as muiStyled } from '@mui/material/styles';

import MuiTypography from '@mui/material/Typography';

export const Typography = muiStyled(MuiTypography)(() => ({
  marginTop: '24px',
  '&.MuiTypography-formHeader:first-of-type': {
    marginTop: 0,
  },
  '&.MuiTypography-formHeader': {
    marginTop: '44px',
    marginBottom: '10px',
  },
}));

export const SidePanelImage = styled.img`
  max-width: 40px;
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 250px;
  border: 1px solid #c4c4c4;
  resize: none;
  border-radius: 4px;
`;
